import { Button } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import type { EditableCallbackParams } from "ag-grid-community";
import { downloadQCBDFile } from "../utils/downloadQCBDFile";

type Props = EditableCallbackParams;

export const QCBDDownloadButton = ({ data }: Props) => {
	const handleDownloadClick = () => {
		if (data?.URL && data?.Filename) {
			downloadQCBDFile(data.URL, data.Filename);
		}
	};

	return (
		<Grid2 container spacing={1} style={{ alignItems: "center" }}>
			{data?.URL && data?.Filename && (
				<Grid2 size={{ md: 12, xs: 12 }}>
					<Button
						fullWidth
						variant="outlined"
						style={{
							textDecoration: "none !important",
							fontWeight: 500,
							fontSize: "12px",
							borderRadius: "3px",
							border: "1px solid #3F51B5",
							color: "#3F51B5",
							background: "#FFFF",
						}}
						onClick={handleDownloadClick}
					>
						DOWNLOAD
					</Button>
				</Grid2>
			)}
		</Grid2>
	);
};
